<template>
  <div>
    <app-layout>
      <template v-slot:header>
        <Header :title="$t('out_of_country_request_detail')"
                :isFilter="false"/>
      </template>
      <template v-slot:header-mobile>
        <HeaderMobile :title="$t('out_of_country_request_detail')"
                      :isFilter="false"/>
      </template>
      <div>
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <h6 class="text-uppercase mb-0">
                {{ toUpperCase('application_information') }}
              </h6>
            </div>
          </div>
          <div class="col-12">
            <b-row>
              <div class="col-12">
                <div class="border rounded p-4 mb-3 h-100">
                  <div class="mb-4">
                    <h6 class="text-uppercase mb-0">
                      {{ $t('student_information').toUpper() }}
                    </h6>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 col-md-12 col-xl-4">
                      <b-form-group :label="$t('student_id')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'student_number') }}</span>
                      </b-form-group>
                    </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('sevis_id')">
                        <span>
                          {{ outOfCountryData.sevis_id }}</span>
                          </b-form-group>
                      </div>
                    <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                      <b-form-group :label="$t('full_name')">
                        <span>
                          {{ outOfCountryData.name?outOfCountryData.name:'-' + ' ' + outOfCountryData.surname }}
                        </span>
                      </b-form-group>
                    </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('module_status')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'module_status')}}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('status')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'status_name') }}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('estimated_date_of_departure')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'estimated_departure_date')}}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('estimated_date_of_return')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'estimated_return_date') }}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('confirmed_departure_date')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'confirmed_departure_date') }}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('confirmed_return_date')">
                        <span>
                          {{ this.getObjectValue(outOfCountryData,'confirmed_return_date') }}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('reason')">
                              <b-form-textarea
                                  id="textarea"
                                  v-model="outOfCountryData.reason"
                                  rows="5"
                                  max-rows="6"
                                  :disabled="true"
                              ></b-form-textarea>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('denial_explanation')">
                              <b-form-textarea
                                  id="textarea"
                                  :disabled="true"
                                  v-model="outOfCountryData.denial_explanation"
                                  rows="5"
                                  max-rows="6"
                              ></b-form-textarea>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4">
                          <b-form-group :label="$t('good_standing')">
                        <span>
                          {{this.getObjectValue( outOfCountryData,'good_standing') }}</span>
                          </b-form-group>
                      </div>
                      <div class="col-12 col-sm-6 col-md-6 col-xl-4" v-if="checkPermission('studentoutofcountryrequest_download')">

                          <b-form-group :label="$t('download') + ' ' + $t('ticket')" class="mb-0">
                              <template v-if="outOfCountryData.ticket">
                                  <b-button
                                      class="rounded d-flex align-items-center justify-content-center p-2"
                                      variant="outline-primary"
                                      style="min-width: 50px; min-height: 50px;"
                                      v-b-tooltip.hover="$t('download_ticket')"
                                      @click="downloadFile(outOfCountryData.ticket)"
                                  >
                                      <i class="ri-file-download-line ri-2x font-weight-bold"></i>
                                  </b-button>
                              </template>

                              <template v-else>
                                  <div
                                      class="rounded d-flex align-items-center justify-content-center bg-light border text-muted"
                                      style="min-width: 50px; min-height: 50px; border-style: dashed !important;"
                                      v-b-tooltip.hover="$t('no_ticket_uploaded')"
                                  >
                                      <div class="text-center">
                                          <i class="ri-file-forbid-line ri-xl d-block"></i>
                                          <small style="font-size: 10px;" class="font-weight-bold text-uppercase">
                                              {{ $t('not_found') }}
                                          </small>
                                      </div>
                                  </div>
                              </template>
                          </b-form-group>
                      </div>
                  </div>
                </div>
              </div>
            </b-row>
                <ConfirmationForm v-if="['MA','A'].includes(userRoles) &&
                 ['waiting_review'].includes(outOfCountryData.status)"
                 @successReview="getOutOfCountryRequest"/>

              <div class="rounded ml-0 mb-3 mt-4 w-100">
                <div v-if="selectedActiveStepRole">
                    <I20UploadFile
                        v-if="['waiting_dso_signature'].includes(outOfCountryData.status) &&
                         ['approved'].includes(updateStep.status)"
                         ref="i20UploadFileRef"
                    />
                    <FinalizedDate
                        v-if="['MA'].includes(userRoles) &&
                        ['waiting_mentora_admin_date_approval'].includes(outOfCountryData.status) &&
                        ['approved'].includes(updateStep.status)"
                        @successFinalized="getOutOfCountryRequest"
                        ref="finalizedDate"
                    />
                    <ValidationObserver ref="updateForm">
                            <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('status')">
                                        <multi-selectbox
                                            :multiple="false"
                                            v-model="updateStep.status"
                                            :options="statusOptions"
                                            :validate-error="errors[0]"
                                        />
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 col-xl-6" v-if="['declined'].includes(updateStep.status)">
                                <ValidationProvider name="reason" :rules="['declined'].includes(updateStep.status)?'required':''" v-slot="{valid, errors}">
                                    <b-form-group :label="$t('reason')">
                                        <b-form-textarea v-model="updateStep.reason"
                                                         :class="errors[0] ? 'is-invalid':''"
                                                         rows="5"
                                        />
                                        <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"/>
                                    </b-form-group>
                                </ValidationProvider>
                            </div>
                    </ValidationObserver>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 mb-3">
                            <LoadingButton
                                    :disabled="isLoading"
                                    :loading="isLoading"
                                    :label="$t('approve')"
                                    @click="stepUpdate"/>
                    </div>
                    </div>
                </div>
          </div>
        </div>
        <div v-if="steps" class="mt-2">
          <b-table :empty-text="$t('there_are_no_records')" bordered striped responsive :items="steps"
                   :fields="[
                            { key: 'rank', label: this.toUpperCase('rank'), thClass: 'text-center', tdClass: 'text-center' },
                            { key: 'approvers', label: this.toUpperCase('can_approvers'), thClass: 'text-center' },
                            { key: 'approved', label: this.toUpperCase('approved_by'), thClass: 'text-center' },
                            { key: 'status', label: this.toUpperCase('status'), thClass: 'text-center' },
                            { key: 'reason', label: this.toUpperCase('explanation'), thClass: 'text-center' },
                            { key: 'updated_at', label: this.toUpperCase('updated_at'), thClass: 'text-center' }
                        ]" show-empty sort-by="rank" class="mb-3 table-dropdown no-scrollbar border rounded">
            <template #cell(approvers)="data">
                            <span v-for="(approver, key) in data.item.approvers" :key="key">
                                {{ approver.explanation }} <br>
                            </span>
            </template>
            <template #cell(approved)="data">
                            <span v-for="(approver, key) in data.item.approved" :key="key">
                                {{ approver.name }} {{ approver.surname }}<br>
                            </span>
            </template>
              <template #cell(updated_at)="data">
                  {{formatDate(data.item.updated_at)}}
              </template>
            <template #cell(status)="data">
              {{ data.item.status_name }}
            </template>
          </b-table>
        </div>
      </div>
    </app-layout>
  </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout.vue";
import Header from "@/layouts/AppLayout/Header.vue";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile.vue";

import {ValidationProvider, ValidationObserver} from "vee-validate"
import MentoraTimeOffRequestFormServices from "@/services/MentoraTimeOffRequestFormServices";
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox.vue";
import LoadingButton from "@/components/elements/LoadingButton.vue";

import moment from "moment";
import OutOfCountryMentora from "@/services/OutOfCountryMentoraServices";

import FinalizedDate from "@/modules/mentoraOutOfCountryRequestForm/pages/admin/components/FinalizedDate.vue";
import I20UploadFile from "@/modules/mentoraOutOfCountryRequestForm/pages/admin/components/I20UploadFile.vue";
import ConfirmationForm from "@/modules/mentoraOutOfCountryRequestForm/pages/admin/components/ConfirmationReviewForm.vue";


export default {
  components: {
      ConfirmationForm,
      I20UploadFile,
      FinalizedDate,
    LoadingButton,
    MultiSelectbox,
    AppLayout,
    Header,
    HeaderMobile,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      form: {},
      updateStep: {
        status: null
      },
      outOfCountryData: {},
      step: {},
      steps: [],
      statuses: {},
      statusOptions: [
        {value: null, text: ''},
        {value: 'approved', text: this.$t('approved')},
        {value: 'declined', text: this.$t('declined')},
      ],
      isLoading: false,
    }
  },
  metaInfo() {
    return {
      title: this.$t('out_of_country_request_detail')
    }
  },
  computed: {
    userRoles() {
      return this.$store.getters['auth/getActiveRole']
    },
    selectedActiveStepRole() {
      if (this.steps && this.steps.length > 0) {
          const activeStep=this.steps.find((item)=>item.active)
          if (!activeStep) return false
          return  activeStep.approvers?.[0].name === this.userRoles
      } else {
        return false
      }
    },
     activeStep(){
        if (this.steps && this.steps.length>0){
            return this.steps.find((item) => item.active)
        }
        return  null
     }
  },
  created() {
    this.getOutOfCountryRequest();
  },
  methods: {
      getOutOfCountryRequest() {
        OutOfCountryMentora.show(this.$route.params.id)
          .then(response => {
            this.outOfCountryData = response.data.data;
            this.step = this.outOfCountryData.step == null ? {} : this.outOfCountryData.step;
            this.steps = this.outOfCountryData.steps;
          })
          .catch(e => {
            this.$toast.error(e.data.message)
          })
    },
   async stepUpdate() {
       this.isLoading=true
      if (['waiting_dso_signature'].includes(this.outOfCountryData.status) &&
          ['approved'].includes(this.updateStep.status)) {
          const isUploadSuccess =await this.$refs.i20UploadFileRef.uploadFile()
          if (!isUploadSuccess){
              this.isLoading=false
              return
          }
      }
      if (['MA'].includes(this.userRoles) &&
          ['waiting_mentora_admin_date_approval'].includes(this.outOfCountryData.status) &&
          ['approved'].includes(this.updateStep.status)
      ){
          const isFinalized= await this.$refs.finalizedDate.dateFinalized()
          if (!isFinalized){
              this.isLoading=false
              return
          }
      }
            const isValid = await this.$refs.updateForm.validate();
            if (isValid) {

            let data = {
              status: this.updateStep.status,
            }
            if (['declined'].includes(this.updateStep.status)){
                data.reason = this.updateStep.reason
            }
            MentoraTimeOffRequestFormServices.updateStep(this.activeStep.id, data)
                .then(response => {
                  this.$toast.success(this.$t('api.' + response.data.message));
                  this.isLoading=false
                  this.getOutOfCountryRequest()
                })
                .catch(error => {
                  this.showErrors(error, this.$refs.formObserver)
                    this.isLoading=false
                })
      }
    },
      formatDate(date){
        return moment(date).format('MM/DD/YYYY HH:mm')
      },
      downloadFile(file) {
          if (!file) {
              this.$toast.error(this.$t('file_not_found'));
              return;
          }
          MentoraTimeOffRequestFormServices.downloadTicket(file.uuid)
              .then(response => {
                  this._downloadFile(response, file.file_name)
              }).catch(err => {
              this.showErrors(err)
          })
      },
  },
    }
</script>
